module.exports = __webpack_public_path__ + "images/_/programs/epsHybridAssembly/images/characters/apprenticePointingUp3-8de0bd064b02d2e9ed3688e6ef5bec10.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridAssembly/images/characters/apprenticePointingUp3.png
// module id = 2261
// module chunks = 2